module.exports = __webpack_public_path__ + "img/1WIN.e8524047.svg";